import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useUserRole = (brandId?: string) => {
  const [role, setRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setRole(null);
          setIsLoading(false);
          return;
        }

        if (brandId) {
          // Check if user owns the specific brand
          const { data: brandData } = await supabase
            .from('brands')
            .select('user_id')
            .eq('id', brandId)
            .single();

          if (brandData?.user_id === user.id) {
            setRole('owner');
            setIsLoading(false);
            return;
          }

          // Check user_brand_access table for specific brand
          const { data: accessData } = await supabase
            .from('user_brand_access')
            .select('role')
            .eq('brand_id', brandId)
            .eq('user_id', user.id)
            .single();

          setRole(accessData?.role || null);
        } else {
          // Check if user owns any brand (for system-wide permissions)
          const { data: ownedBrands } = await supabase
            .from('brands')
            .select('id')
            .eq('user_id', user.id)
            .limit(1);

          if (ownedBrands && ownedBrands.length > 0) {
            setRole('owner');
          } else {
            setRole(null);
          }
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRole();
  }, [brandId]);

  return {
    role,
    isLoading,
    isOwner: role === 'owner',
    isAdminOrOwner: role === 'owner' || role === 'admin',
  };
};